const rankingItems = [
  { id: 1, rank: 1, title: '星河长明', type: '古装玄幻', hot: '9.4', trend: 'up', change: '+2' },
  { id: 2, rank: 2, title: '星际纪元', type: '国产动漫', hot: '9.7', trend: 'up', change: '+5' },
  { id: 3, rank: 3, title: '欢乐周末', type: '热门综艺', hot: '9.6', trend: 'same', change: '-' },
  { id: 4, rank: 4, title: '风暴追击', type: '动作大片', hot: '9.1', trend: 'up', change: '+1' },
  { id: 5, rank: 5, title: '暗夜追踪', type: '悬疑新剧', hot: '9.0', trend: 'up', change: '+8' },
  { id: 6, rank: 6, title: '秘密花园', type: '经典韩剧', hot: '8.9', trend: 'down', change: '-3' },
  { id: 7, rank: 7, title: '夏日恋歌', type: '言情剧集', hot: '8.7', trend: 'up', change: '+4' },
];

export default function RankingSection() {
  const getRankBg = (rank: number) => {
    if (rank === 1) return 'bg-accent-500 text-background-50';
    if (rank === 2) return 'bg-secondary-400 text-background-50';
    if (rank === 3) return 'bg-primary-400 text-background-50';
    return 'bg-foreground-200 text-foreground-600';
  };

  const getTrendIcon = (trend: string) => {
    if (trend === 'up') return <i className="ri-arrow-up-line text-primary-500 text-xs"></i>;
    if (trend === 'down') return <i className="ri-arrow-down-line text-foreground-400 text-xs"></i>;
    return <i className="ri-subtract-line text-foreground-400 text-xs"></i>;
  };

  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            热播榜单
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            实时热度排名，看看大家都在追什么
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          {rankingItems.map((item) => (
            <a
              key={item.id}
              href={`#rank-${item.id}`}
              className="flex items-center gap-4 px-4 py-3.5 rounded-xl hover:bg-background-50 transition-colors cursor-pointer group"
            >
              <div
                className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold flex-shrink-0 ${getRankBg(item.rank)}`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </span>
                  <span className="text-xs px-1.5 py-0.5 rounded bg-background-200 text-foreground-600 whitespace-nowrap">
                    {item.type}
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 flex-shrink-0">
                <span className="text-sm font-semibold text-accent-600 whitespace-nowrap">
                  {item.hot}
                </span>
                <span className="flex items-center gap-0.5">
                  {getTrendIcon(item.trend)}
                  <span
                    className={`text-xs whitespace-nowrap ${
                      item.trend === 'up'
                        ? 'text-primary-500'
                        : item.trend === 'down'
                          ? 'text-foreground-400'
                          : 'text-foreground-400'
                    }`}
                  >
                    {item.change}
                  </span>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}